<template>
  <div class="customer-picker-display">
    <avatar :size="20" :person="customer" />
    <span v-if="customer.name===customer.email">{{ customer.email }}</span>
    <span v-else><strong>{{ customer.name }}</strong> &lt;{{ customer.email }}&gt;</span>
    <i v-if="showCaretDown" class="ddi ddi-caret-down" />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'CustomerPickerDisplay',

  props: {
    customer: {
      type: Object as () => IPersonWithEmail,
      required: true,
    },
    showCaretDown: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.customer-picker-display {
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  border: $border--dotted-light;
  border-radius: 48px;
  padding: 4px 8px 4px 4px;

  .ddi-caret-down {
    padding-left: 6px;
    font-size: 12px;
  }

  > span {
    @include lettering--p-sm;
    @include single-line-ellipsis;
    margin-left: 4px;
  }
}
</style>
